import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import qrImage from '../assets/qr.png'

type InviteDialogProps = {
  open: boolean
  onClose: () => void
  onCopy: () => void
}

export const InviteDialog: React.FC<InviteDialogProps> = ({ open, onClose, onCopy }) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle sx={{ position: 'relative', pr: 6 }}>
      <Typography
        sx={{
          fontWeight: 'bold',
        }}
      >
        友達を招待する 🚀
      </Typography>
      <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent sx={{ textAlign: 'center', pb: 3 }}>
      <Box
        component="img"
        src={qrImage}
        alt="招待QRコード"
        sx={{ width: '100%', maxWidth: 200, mb: 2 }}
      />
      <Box
        display="flex"
        alignItems="center"
        gap={1}
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          px: 1.5,
          py: 1,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            flex: 1,
            wordBreak: 'break-all',
            textAlign: 'left',
            color: 'text.secondary',
          }}
        >
          {window.location.origin}/signUp
        </Typography>
        <IconButton size="small" onClick={onCopy}>
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Box>
    </DialogContent>
  </Dialog>
)
